/**
 * Phase 16a (ADR-0023): the bireysel edition's words, kept apart from tr.ts and en.ts (merged in index.ts under
 * `b2cAuth`): sign-in, sign-up, the e-mail code (B2cKayit, B2cDogrulama), the password reset and the draft legal
 * texts. Turkish first; the English mirrors it key for key. The sender's address comes from /api/meta, never from here.
 */
export const b2cAuthTr = {
  b2cAuth: {
    email: 'E-posta',
    password: 'Şifre',
    newPassword: 'Yeni şifre',
    showPassword: 'Şifreyi göster',
    hidePassword: 'Şifreyi gizle',
    passwordHint: 'En az 10 karakter',
    passwordFooter: 'Şifreniz bizde açık hâliyle saklanmaz.',
    // a button waiting out a limit: "Giriş yap (0:42)"
    countdown: '{{label}} ({{time}})',
    wait_seconds_one: '{{count}} saniye sonra yeniden deneyin.',
    wait_seconds_other: '{{count}} saniye sonra yeniden deneyin.',
    wait_minutes_one: '{{count}} dakika sonra yeniden deneyin.',
    wait_minutes_other: '{{count}} dakika sonra yeniden deneyin.',
    waitOver: 'Şimdi yeniden deneyebilirsiniz.',
    // a field's problem, under the field
    fields: {
      nameMissing: 'Ad soyadınızı yazın.',
      nameInvalid: 'Ad soyadınızı kontrol edin; en çok 120 karakter olabilir.',
      email: 'Geçerli bir e-posta adresi yazın.',
      passwordMissing: 'Şifrenizi yazın.',
      passwordShort: 'Şifre en az 10 karakter olmalı.',
      passwordLong: 'Şifre en çok 256 karakter olabilir.',
      passwordBreached: 'Bu şifre çok yaygın ya da sızdırılmış şifre listelerinde var. Başka bir şifre seçin.',
      terms: 'Devam etmek için Kullanım Koşulları’nı kabul edin.',
    },
    // the banner of a refused request: a strong first sentence, then what to do
    errors: {
      invalid: { title: 'E-posta ya da şifre yanlış.', action: 'Bilgilerinizi kontrol edip yeniden deneyin.' },
      unavailable: { title: 'Oppy’ye şu an ulaşılamıyor.', action: 'Birkaç dakika sonra yeniden deneyin.' },
      locked: { title: 'Çok fazla deneme.', action: 'Biraz bekleyip yeniden deneyin.' },
      deactivated: { title: 'Bu hesap kullanıma kapalı.', action: 'Yardım için destek ekibine yazın.' },
      relink: { title: 'Bu hesapla burada giriş yapılamıyor.', action: 'Yardım için destek ekibine yazın.' },
      check: { title: 'Yazdıklarınızı kontrol edin.', action: 'Sonra yeniden deneyin.' },
      failed: { title: 'Bir sorun oldu.', action: 'Sayfayı yenileyip yeniden deneyin.' },
    },
    login: {
      title: 'Giriş yapın',
      remember: '30 gün hatırla',
      forgot: 'Şifremi unuttum',
      submit: 'Giriş yap',
      noAccount: 'Hesabınız yok mu?',
      signup: 'Hesap oluştur',
    },
    signup: {
      title: 'Hesap oluşturun',
      subtitle: 'Ücretsiz başlayın; kart gerekmez.',
      name: 'Ad soyad',
      terms: '<terms>Kullanım Koşulları</terms>’nı okudum ve kabul ediyorum.',
      marketing: 'Yenilikler ve kampanyalarla ilgili e-posta almak istiyorum.',
      optional: '(isteğe bağlı)',
      privacy: 'Kişisel verileriniz <privacy>KVKK Aydınlatma Metni</privacy>’nde anlatıldığı gibi işlenir.',
      submit: 'Hesap oluştur',
      haveAccount: 'Hesabınız var mı?',
      login: 'Giriş yapın',
    },
    verify: {
      title: 'E-postanızı doğrulayın',
      subtitle: '{{email}} adresine 6 haneli bir kod gönderdik.',
      code: 'Doğrulama kodu',
      digit: '{{n}}. hane',
      submit: 'Doğrula',
      // the line break is for wide screens; a phone lets the line wrap
      help: 'Kod gelmedi mi? İstenmeyen e-postalar klasörüne bakın <br/>ya da <resend>yeniden gönderin</resend> · <change>E-postayı değiştir</change>',
      resendWait: '({{time}})',
      sent: 'Yeni kod gönderildi.',
      info: 'Kod 10 dakika geçerlidir. E-posta <b>{{address}}</b> adresinden gelir.',
      infoShort: 'Kod 10 dakika geçerlidir.',
      footer: 'Doğruladıktan sonra Ücretsiz paketle başlarsınız.',
      errors: {
        invalid: {
          title: 'Kod doğru değil.',
          action_one: '{{count}} deneme hakkınız kaldı.',
          action_other: '{{count}} deneme hakkınız kaldı.',
          retype: 'Kodu kontrol edip yeniden yazın.',
        },
        expired: { title: 'Kodun süresi doldu ya da çok kez yanlış girildi.', action: 'Yeni kod isteyin.' },
        unknown: { title: 'Bu kayıt artık geçerli değil.', action: '<signup>Yeniden hesap oluşturun</signup>.' },
        incomplete: { title: 'Kod eksik.', action: 'Kodun 6 hanesini de yazın.' },
      },
    },
    forgot: {
      title: 'Şifrenizi mi unuttunuz?',
      subtitle: 'E-posta adresinizi yazın; hesabınız varsa şifre sıfırlama bağlantısı göndeririz.',
      submit: 'Bağlantı gönder',
      doneTitle: 'E-postanıza bakın',
      done: '<b>{{email}}</b> adresine ait bir hesap varsa şifre sıfırlama bağlantısı gönderdik. Bağlantı 30 dakika geçerlidir.',
      spam: 'E-posta gelmezse istenmeyen e-postalar klasörüne bakın.',
      back: 'Giriş sayfasına dön',
    },
    reset: {
      title: 'Yeni şifre belirleyin',
      submit: 'Şifreyi kaydet',
      done: 'Şifreniz değişti. <login>Giriş yapın</login>.',
      invalid: 'Bağlantı geçersiz ya da süresi dolmuş.',
      newLink: 'Yeni bağlantı isteyin',
    },
    legal: {
      draft: 'Taslak',
      draftNote: 'Bu metin taslaktır; avukat onayından sonra son hâlini alacak.',
      version: 'Sürüm: {{version}}',
      back: 'Oppy’ye dön',
      notFound: 'Bu metin bulunamadı.',
      notFoundHint: 'Adresi kontrol edin.',
    },
  },
};

export const b2cAuthEn: typeof b2cAuthTr = {
  b2cAuth: {
    email: 'Email',
    password: 'Password',
    newPassword: 'New password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    passwordHint: 'At least 10 characters',
    passwordFooter: 'We never store your password in plain text.',
    countdown: '{{label}} ({{time}})',
    wait_seconds_one: 'Try again in {{count}} second.',
    wait_seconds_other: 'Try again in {{count}} seconds.',
    wait_minutes_one: 'Try again in {{count}} minute.',
    wait_minutes_other: 'Try again in {{count}} minutes.',
    waitOver: 'You can try again now.',
    fields: {
      nameMissing: 'Enter your full name.',
      nameInvalid: 'Check your name; it can be at most 120 characters.',
      email: 'Enter a valid email address.',
      passwordMissing: 'Enter your password.',
      passwordShort: 'Your password needs at least 10 characters.',
      passwordLong: 'Your password can be at most 256 characters.',
      passwordBreached: 'This password is too common or appears in lists of leaked passwords. Choose another one.',
      terms: 'Accept the Terms of Use to continue.',
    },
    errors: {
      invalid: { title: 'Incorrect email or password.', action: 'Check what you entered and try again.' },
      unavailable: { title: 'Oppy can’t be reached right now.', action: 'Try again in a few minutes.' },
      locked: { title: 'Too many attempts.', action: 'Wait a moment and try again.' },
      deactivated: { title: 'This account is turned off.', action: 'Write to the support team for help.' },
      relink: { title: 'This account cannot sign in here.', action: 'Write to the support team for help.' },
      check: { title: 'Check what you entered.', action: 'Then try again.' },
      failed: { title: 'Something went wrong.', action: 'Reload the page and try again.' },
    },
    login: {
      title: 'Sign in',
      remember: 'Remember for 30 days',
      forgot: 'Forgot password',
      submit: 'Sign in',
      noAccount: 'Don’t have an account?',
      signup: 'Create account',
    },
    signup: {
      title: 'Create your account',
      subtitle: 'Start for free; no card needed.',
      name: 'Full name',
      terms: 'I have read and accept the <terms>Terms of Use</terms>.',
      marketing: 'I’d like to receive emails about news and offers.',
      optional: '(optional)',
      privacy: 'Your personal data is processed as described in the <privacy>KVKK Privacy Notice</privacy>.',
      submit: 'Create account',
      haveAccount: 'Already have an account?',
      login: 'Sign in',
    },
    verify: {
      title: 'Verify your email',
      subtitle: 'We sent a 6-digit code to {{email}}.',
      code: 'Verification code',
      digit: 'Digit {{n}}',
      submit: 'Verify',
      help: 'Didn’t get the code? Check your spam folder <br/>or <resend>send it again</resend> · <change>Change email</change>',
      resendWait: '({{time}})',
      sent: 'A new code is on its way.',
      info: 'The code is valid for 10 minutes. The email comes from <b>{{address}}</b>.',
      infoShort: 'The code is valid for 10 minutes.',
      footer: 'Once verified, you start on the Free plan.',
      errors: {
        invalid: {
          title: 'That code isn’t right.',
          action_one: 'You have {{count}} try left.',
          action_other: 'You have {{count}} tries left.',
          retype: 'Check the code and type it again.',
        },
        expired: { title: 'The code has expired or was entered wrong too many times.', action: 'Ask for a new code.' },
        unknown: { title: 'This sign-up is no longer valid.', action: '<signup>Create your account again</signup>.' },
        incomplete: { title: 'The code is incomplete.', action: 'Type all 6 digits.' },
      },
    },
    forgot: {
      title: 'Forgot your password?',
      subtitle: 'Enter your email address; if you have an account, we’ll send you a link to reset your password.',
      submit: 'Send link',
      doneTitle: 'Check your email',
      done: 'If an account exists for <b>{{email}}</b>, we’ve sent a link to reset your password. The link is valid for 30 minutes.',
      spam: 'If the email doesn’t arrive, check your spam folder.',
      back: 'Back to sign in',
    },
    reset: {
      title: 'Set a new password',
      submit: 'Save password',
      done: 'Your password has changed. <login>Sign in</login>.',
      invalid: 'The link is invalid or has expired.',
      newLink: 'Ask for a new link',
    },
    legal: {
      draft: 'Draft',
      draftNote: 'This text is a draft; it becomes final once a lawyer approves it.',
      version: 'Version: {{version}}',
      back: 'Back to Oppy',
      notFound: 'This text could not be found.',
      notFoundHint: 'Check the address.',
    },
  },
};
